
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web/privacy-policy",
      function () {
        return require("private-next-pages/web/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/web/privacy-policy"])
      });
    }
  